module.exports = __webpack_public_path__ + "img/docs_verification.1c6106ad.svg";